import { useQuery } from '@tanstack/react-query';
import { schoolService } from '../../../services';

interface UseSchoolsOptions {
  per_page?: number;
  enabled?: boolean;
}

const useSchools = (options: UseSchoolsOptions = {}) => {
  const { per_page = 1000, enabled = true } = options;

  return useQuery({
    queryKey: ['schools', { per_page }],
    queryFn: () => schoolService.getSchools({ per_page }),
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
};

export { useSchools };
